{
  "gnin.fps-redirect.changeboarding.description": [
    {
      "type": 0,
      "value": "Looking for more? Switch to find results and answers from all your Atlassian and connected apps."
    }
  ],
  "gnin.fps-redirect.changeboarding.primary-button": [
    {
      "type": 0,
      "value": "Got it"
    }
  ],
  "gnin.fps-redirect.changeboarding.title": [
    {
      "type": 0,
      "value": "Switch to search beyond Jira"
    }
  ],
  "post-office.quick-find-spotlight.spotlight-body-1": [
    {
      "type": 0,
      "value": "Apply a mix of filters to narrow down results."
    }
  ],
  "post-office.quick-find-spotlight.spotlight-body-2": [
    {
      "type": 0,
      "value": "Search only Jira, or expand across all your Atlassian and connected apps."
    }
  ],
  "post-office.quick-find-spotlight.spotlight-button-done": [
    {
      "type": 0,
      "value": "Done"
    }
  ],
  "post-office.quick-find-spotlight.spotlight-button-next": [
    {
      "type": 0,
      "value": "Next"
    }
  ],
  "post-office.quick-find-spotlight.spotlight-heading-1": [
    {
      "type": 0,
      "value": "Filter for what you need"
    }
  ],
  "post-office.quick-find-spotlight.spotlight-heading-2": [
    {
      "type": 0,
      "value": "Choose where to search"
    }
  ]
}